







































































































































































































































































































































































































































































































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import { FacilityModule } from '@/store/modules/facility.module'
import { UserModule } from '@/store/modules/user.module'
import { PHONE_MASK, STORAGE_URL, US_STATES_LIST, ZIP_MASK } from '@/constants'
import { EOrigin, EUserPermissions, EUserStatus, IFacility, isNumber, IUser } from '@zunta/configurations'
import Api from '@/api'
import Card from '@/components/Card.vue'
import UpdateFacilityModal
  from '@/views/app/management/settings/pages/facility/information/components/UpdateFacilityModal.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import Switcher from '@/components/Switcher.vue'
import InputPassword from '@/components/inputsV2/InputPassword.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import Icon from '@/components/Icon.vue'
import Editable from '@/components/inputsV2/Editable.vue'
import { email, minLength, numeric, required, requiredIf } from 'vuelidate/lib/validators'
import InputFileV2 from '@/components/inputsV2/InputFileV2.vue'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import { getSelectContentLabel, isProductionEnv } from '@/utils/helpers'
import FileInput from '@/components/inputs/FileInput.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import StatusFacilityComplete from '@/components/statuses/StatusFacilityComplete.vue'
import CircleChart from '@/components/chart/CircleChart.vue'
import { VPopover } from 'v-tooltip'
import Confirm from '@/components/Confirm.vue'
import { getFacilityGeneralInfoCompleteLevel } from '@/utils/facility/facilityLevels'

@Component({
  components: {
    FileInput,
    InputValidator,
    InputFileV2,
    Editable,
    Icon,
    LoaderWrapper,
    InputPassword,
    SelectV2,
    InputV2,
    UpdateFacilityModal,
    Card,
    StatusFacilityComplete,
    CircleChart,
    VPopover,
    Checkbox,
    Switcher,
    Confirm
  }
})
export default class FacilityInfo extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  EUserPermissions: any = EUserPermissions
  EOrigin: any = EOrigin
  user: any = Api.getUser()
  getSelectContentLabel: Function = getSelectContentLabel

  PHONE_MASK: string = PHONE_MASK
  ZIP_MASK: string = ZIP_MASK

  facilityData: Partial<IFacility> = {}
  showNcsIntegrationUpdateConfirmation = false
  originid = ''
  directory = ''
  isLoading: boolean = false
  isLoadingFile: boolean = false

  shouldUpdateFacilityModalOpened: boolean = false
  preventUpdate: boolean = true

  updater: number = 0
  showToggleConfirm: boolean = false
  toggleToChange: string | null = null

  get requiredFields () {
    const fields = [{
      value: 'name',
      label: 'Name'
    }, {
      value: 'street',
      label: 'Address'
    }, {
      value: 'city',
      label: 'City'
    }, {
      value: 'state',
      label: 'State'
    }, {
      value: 'zip',
      label: 'Zip Code'
    }, {
      value: 'phone',
      label: 'Phone'
    }, {
      value: 'residentBillingContact',
      condition: this.selectedUserHasAccessToFacility,
      label: 'Billing Contact'
    }, {
      value: 'logo',
      label: 'Logo'
    }]
    if (this.selectedFacility.origin === EOrigin.PCC) {
      fields.push({
        value: 'username',
        label: 'PCC Username'
      })
    } else {
      if (!this.originid && !this.directory) {
        fields.push({
          value: 'directory',
          label: 'File Directory'
        },
        {
          value: 'originid',
          label: 'NCS Company Id'
        })
      }
      if (this.directory) {
        fields.push({
          value: 'directory',
          label: 'File Directory'
        })
      }
      if (this.originid) {
        fields.push({
          value: 'originid',
          label: 'NCS CompanyId'
        })
      }
    }
    return fields
  }

  validations (): any {
    return {
      facilityData: {
        name: {
          required
        },
        shortName: {
          // required
        },
        email: {
          email
          // required
        },
        street: {
          // required
        },
        state: {
          // required
        },
        city: {
          // required
        },
        zip: {
          // required,
          numeric,
          minLength: minLength(5)
        },
        phone: {
          // required,
          phone: (val: any) => !val || /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(val)
        },
        website: {
          // required,
          valid: (val: any) => !val || /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/.test(val)
        },
        residentBillingContact: {
          // required
        },
        directory: {
          required: requiredIf(() => !this.originid)
        },
        originid: {
          required: requiredIf(() => !this.directory)
        },
        username: {
          // required: requiredIf(() => this.isPcc)
        },
        password: {
          // required: requiredIf(() => this.isPcc)
        }
      }
    }
  }

  get isSuperAdmin () {
    return this.user.isRootAccess()
  }

  get hasEditPermission () {
    return this.user.hasPermissionFor(EUserPermissions.EDIT_FACILITY_INFORMATION)
  }

  get facilityManagersList () {
    return this.$store.state.user.users
  }

  get facilityCompleteLevel () {
    return getFacilityGeneralInfoCompleteLevel(this.selectedFacility, this.userIds)
  }

  get completedData () {
    this.updater++
    return [{
      value: 100 - this.facilityCompleteLevel,
      text: '',
      color: '#ffffff'
    },
      {
        value: this.facilityCompleteLevel,
        text: '',
        color: 'currentColor'
      }]
  }

  get statesList () {
    return Object.keys(US_STATES_LIST).map((stateShortName: string) => ({
      value: stateShortName,
      key: stateShortName,
      content: US_STATES_LIST[stateShortName]
    }))
  }

  get facilityManagersListForSelect () {
    if (!this.facilityManagersList || !this.facilityManagersList.length || !this.selectedFacility) {
      return []
    }

    return this.facilityManagersList
      .filter((manager: IUser) => {
        const isActive: boolean = manager.status === EUserStatus.ACTIVE

        const hasAccessToFacility: boolean =
          manager.isAllFacilities ||
          !!(manager.facilities && manager.facilities.length && manager.facilities.map((Number)).includes(Number(this.selectedFacility.id)))

        const equalsToSelected: boolean = this.facilityData.residentBillingContact
          ? Number(this.facilityData.residentBillingContact) === manager.id
          : false

        return (isActive && hasAccessToFacility) || equalsToSelected
      })
      .map((manager: IUser) => ({
        key: 'manager' + manager.id,
        value: manager.id,
        content: `${manager.firstName} ${manager.lastName}`
      }))
  }

  get selectedFacility () {
    return this.$store.state.facility.selectedFacility
  }

  get isPcc () {
    return this.selectedFacility.origin === EOrigin.PCC
  }

  get isNcs () {
    return this.selectedFacility.origin === EOrigin.NCS
  }

  get isNCSApi () {
    return this.selectedFacility.origin === EOrigin.NCS && this.originid && isNumber(Number(this.originid))
  }

  get integrationAccountName () {
    return this.isNCSApi ? 'Microsoft' : EOrigin.PCC
  }

  get isManual () {
    return this.selectedFacility.origin === 'MANUAL'
  }

  get facilityLogoPath () {
    return this.selectedFacility ? `${STORAGE_URL}?file=` : ''
  }

  get userIds () {
    return this.facilityManagersListForSelect.map((option: any) => option.value)
  }

  get selectedUserHasAccessToFacility () {
    return this.selectedFacility.residentBillingContact &&
      this.userIds.includes(+this.selectedFacility.residentBillingContact)
  }

  saveNcsInegration () {
    this.facilityData = { ...this.facilityData, originid: this.originid, directory: this.directory }
    this.save(this.originid ? 'originid' : 'directory')
    this.showNcsIntegrationUpdateConfirmation = false
  }

  updateNcsIntegration (value: string, field: string) {
    // @ts-ignore
    if (value && this.facilityData[field] !== value) {
      this.showNcsIntegrationUpdateConfirmation = true
    }
  }

  focusInput (fieldName: string) {
    if (fieldName === 'logo') {
      // @ts-ignore
      this.$refs[fieldName].isDragOver = true
      // @ts-ignore
      this.$refs[fieldName].focusInput()
      setTimeout(() => {
        // @ts-ignore
        this.$refs[fieldName].isDragOver = false
      }, 1500)
      return
    }
    this.$eventBus.$emit(`focusInput`, fieldName)
  }

  initFacilityData () {
    if (!this.selectedFacility) {
      return
    }
    this.facilityData = JSON.parse(JSON.stringify(this.selectedFacility))
    this.originid = this.facilityData.originid || ''
    this.directory = this.facilityData.directory || ''
    this.$nextTick(() => {
      this.preventUpdate = false
    })
  }

  async uploadLogo (file: File) {
    if (!this.selectedFacility) {
      return
    }

    await this.facilityModuleInstance.uploadLogo({
      facilityId: this.selectedFacility.id,
      logo: file
    })
    this.preventUpdate = true
    this.initFacilityData()
  }

  async removeLogo () {
    try {
      this.isLoading = true
      await this.facilityModuleInstance.updateFacility({
        id: this.selectedFacility.id,
        data: {
          logo: ''
        }
      })
    } finally {
      this.selectedFacility.logo = ''
      this.preventUpdate = true
      this.initFacilityData()
      this.isLoading = false
    }
  }

  async save (field: string) {
    if (!this.selectedFacility || !this.hasEditPermission || this.preventUpdate) {
      return
    }

    this.$v.$touch()

    if (this.$v.$anyError) {
      return
    }

    // @ts-ignore
    if (field && this.selectedFacility[field] === this.facilityData[field]) {
      return
    }

    const credentialsChanged = (this.facilityData.password && this.facilityData.password !== this.selectedFacility.password) ||
      (this.selectedFacility.username && this.selectedFacility.username !== this.facilityData.username)

    try {
      this.isLoading = true
      const payload: any = JSON.parse(JSON.stringify(this.facilityData))
      delete payload.logo
      this.facilityData.password = this.selectedFacility.password

      let reloadList = false
      if (
        (this.selectedFacility.name !== this.facilityData.name) ||
        (this.facilityData.shortName !== this.selectedFacility.shortName)
      ) {
        reloadList = true
        this.$eventBus.$emit('reload-facility-list')
      }
      const res = await this.facilityModuleInstance.updateFacility({
        id: this.selectedFacility.id,
        data: {
          ...payload,
          credentialsChanged: !!credentialsChanged
        }
      })
      this.updater++

      if (reloadList) {
        this.$eventBus.$emit('reload-facility-list')
      }

      if (!res) {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          header: `Credentials are incorrect`,
          icon: 'warning'
        })
        return
      }

      if (credentialsChanged) {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-success-color)',
          header: `Credentials are updated`,
          icon: 'check'
        })
      }
    } finally {
      if (field === 'name') {
        this.$eventBus.$emit('reload-facility-list')
      }
      setTimeout(() => (this.isLoading = false), 300)
    }
  }

  reports: any = []
  contactsReport = ''
  residentsReport = ''
  transactionsReport = ''

  openUpdateFacilityModal () {
    this.shouldUpdateFacilityModalOpened = true
  }

  closeUpdateFacilityModal () {
    this.shouldUpdateFacilityModalOpened = false
  }

  async mounted () {
    this.initFacilityData()
    this.$watch(() => (this.facilityCompleteLevel), () => {
       this.facilityModuleInstance.SET_FACILITY_COMPLETE_LEVEL([
        { type: 'generalInfo', value: this.facilityCompleteLevel }
      ])
    })
    await this.userModuleInstance.getManagementUsersList({ status: EUserStatus.ACTIVE })
  }

  setManualPCCField (field: string) {
    if (isProductionEnv()) {
      this.showToggleConfirm = true
      this.toggleToChange = field
      return
    }
    return this.save(field)
  }

  cancelManualPCCFieldChange () {
    if (this.toggleToChange) {
      // @ts-ignore
      this.facilityData[this.toggleToChange] = this.selectedFacility[this.toggleToChange]
      this.showToggleConfirm = false
      this.toggleToChange = null
    }
  }

  async uploadCsvContacts (event: any) {
    this.isLoadingFile = true
    const res = await Api.facility.uploadResidentContacts(this.selectedFacility.id, event)
    if (res.error) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: res.message,
        header: `Upload resident contact error`,
        icon: 'warning'
      })
    } else {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        message: '',
        header: `Contacts successfully uploaded`,
        icon: 'check'
      })
    }
    this.isLoadingFile = false
  }
}
